Element.prototype.on = function (eventName, selector, fn) {
  this.addEventListener(eventName, function (event) {
    const possibleTargets = this.querySelectorAll(selector);
    const target = event.target;
    for (let i = 0, l = possibleTargets.length; i < l; i++) {
      const p = possibleTargets[i];
      let el = target;
      while (el && el !== this) {
        if (el === p) {
          return fn.call(p, event, el);
        }
        el = el.parentNode;
      }
    }
  });
}


// WEBPACK FOOTER //
// ./resources/js/utils/_event-delegation.js